import { Editor } from '@tiptap/core';

import { IconName } from 'components/elements/types';

import i18n from './i18n';

type TableAction = {
  name: string;
  icon: IconName;
  message: typeof i18n[keyof typeof i18n];
  command: (editor: Editor) => void;
  canRun: (editor: Editor) => boolean;
  danger?: boolean;
};

export const TABLE_ACTIONS: Record<string, TableAction> = {
  addRowBefore: {
    name: 'addRowBefore',
    icon: 'ArrowLineUp',
    message: i18n.tableAddRowAbove,
    command: (editor) => editor.chain().focus().addRowBefore().run(),
    canRun: (editor) =>
      editor.can().addRowBefore() && !editor.isActive('tableHeader'),
  },
  addRowAfter: {
    name: 'addRowAfter',
    icon: 'ArrowLineDown',
    message: i18n.tableAddRowBelow,
    command: (editor) => editor.chain().focus().addRowAfter().run(),
    canRun: (editor) => editor.can().addRowAfter(),
  },
  addColumnBefore: {
    name: 'addColumnBefore',
    icon: 'ArrowLineLeft',
    message: i18n.tableAddColLeft,
    command: (editor) => editor.chain().focus().addColumnBefore().run(),
    canRun: (editor) => editor.can().addColumnBefore(),
  },
  addColumnAfter: {
    name: 'addColumnAfter',
    icon: 'ArrowLineRight',
    message: i18n.tableAddColRight,
    command: (editor) => editor.chain().focus().addColumnAfter().run(),
    canRun: (editor) => editor.can().addColumnAfter(),
  },
  mergeCells: {
    name: 'mergeCells',
    icon: 'ArrowsInSimple',
    message: i18n.tableMergeCells,
    command: (editor) => editor.chain().focus().mergeCells().run(),
    canRun: (editor) => editor.can().mergeCells(),
  },
  splitCell: {
    name: 'splitCell',
    icon: 'ArrowsOutSimple',
    message: i18n.tableSplitCell,
    command: (editor) => editor.chain().focus().splitCell().run(),
    canRun: (editor) => editor.can().splitCell(),
  },
  deleteRow: {
    name: 'deleteRow',
    icon: 'Rows',
    message: i18n.tableDeleteRow,
    command: (editor) => editor.chain().focus().deleteRow().run(),
    canRun: (editor) => editor.can().deleteRow(),
    danger: true,
  },
  deleteColumn: {
    name: 'deleteColumn',
    icon: 'Columns',
    message: i18n.tableDeleteCol,
    command: (editor) => editor.chain().focus().deleteColumn().run(),
    canRun: (editor) => editor.can().deleteColumn(),
    danger: true,
  },
  deleteTable: {
    name: 'deleteTable',
    icon: 'Trash',
    message: i18n.tableDeleteTable,
    command: (editor) => editor.chain().focus().deleteTable().run(),
    canRun: (editor) => editor.can().deleteTable(),
    danger: true,
  },
};

export const TABLE_ACTION_GROUPS = [
  ['addRowBefore', 'addRowAfter', 'addColumnBefore', 'addColumnAfter'],
  ['mergeCells', 'splitCell'],
  ['deleteRow', 'deleteColumn', 'deleteTable'],
];
